import { Container, Text } from '@pixi/react'

interface BlindProps {
  x: number
  y: number
  name: string
}

export const Blind = (props: BlindProps) => {
  return (
    <Container visible={false} name={props.name} x={props.x} y={props.y}>
      <Text text="blind" />
    </Container>
  )
}
